import { MenuItem } from 'primeng/api';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-class-selector',
  templateUrl: './class-selector.component.html',
  styleUrls: ['./class-selector.component.scss'],
})
export class ClassSelectorComponent implements OnInit {
  @Input() selectedRace!: Race;
  @Input() raceClasses!: RaceClass[];
  @Input() selectedClass!: RaceClass;
  @Input() showOverAll: boolean = true;
  @Output() refresh: EventEmitter<RaceClass> = new EventEmitter();
  items: MenuItem[] = [];

  constructor(public appSettings: SettingsService) {}

  emitClass(classItem: RaceClass) {
    this.selectedClass = classItem;
    this.buildDropDownMenu();
    this.refresh.emit(this.selectedClass);
  }

  ngOnInit() {
    this.buildDropDownMenu();
  }

  buildDropDownMenu() {
    this.items = [];
    this.raceClasses.forEach((classItem) => {
      if (classItem.clUid === this.selectedClass.clUid) return;
      if (!this.showOverAll && classItem.clUid == 'OVERALL_STANDINGS') return;
      this.items.push({
        label: classItem.name,
        command: () => {
          this.emitClass(classItem);
        },
      });
    });
  }
}
